import { Avatar } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { nexcalLogo } from "../../../assets";

const Topbar = () => {
	const navigate = useNavigate();
	const [name, setName] = useState("");
	const handleLogoutClick = useCallback(() => {
		localStorage.removeItem("@jwt");
		alert("You have successfully logged out of IDR Nexcaliber Portal");
		navigate("/");
	}, [navigate]);

	useEffect(() => {
		if (localStorage.getItem("@user") !== null) {
			const user = JSON.parse(localStorage.getItem("@user") as string);
			setName(user.first_name + " " + user.last_name);
		}
	}, []);

	return (
		<div className="topbar">
			<div className="dashboard">
				<div className="logo" style={{ marginLeft: "auto", marginRight: "auto" }}>
					<img src={nexcalLogo} />
				</div>
				<div className="toolbar">
					<a style={{ borderBottom: "none", textDecoration: "none" }} href="/idr/dashboard">
						<div className="login-text">IDR Nexcaliber</div>
					</a>
					<div className="user-cont">
						<div className="username">
							{name}
							<div className="logout" onClick={handleLogoutClick}>
								Logout
							</div>
						</div>
						<div className="avatar-cont">
							<Avatar>{name[0]}</Avatar>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Topbar;
